/**
 * How a tender kind is named to a human.
 *
 * Shared rather than declared twice: it started in the end-of-day report, and
 * the receipt printing `gift_card` where the report said "Gift card" is the
 * same class of drift as a style rule living in one feature's stylesheet and
 * working elsewhere only by accident.
 */
export const TENDER_LABELS: Readonly<Record<string, string>> = {
  cash: 'Cash',
  card: 'Card',
  gift_card: 'Gift card',
  store_credit: 'Store credit',
  // US spelling: this prints on receipts and on the end-of-day report for a
  // shop whose customers write "check" on the thing they are handing over.
  check: 'Check',
  exchange_credit: 'Exchange credit',
};
